var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.reportUrl)?_c('div',[_c('iframe',{staticStyle:{"height":"60rem"},attrs:{"src":_vm.reportUrl,"width":"100%","frameborder":"0"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }